import { DateTime } from "luxon";

const CambiarFormatoFechaConHoraHelper = (fecha) => {
  let manejador = DateTime.fromISO(fecha)
    .setZone("America/Mexico_City")
    .toFormat("f");

  if (manejador == "Invalid DateTime") {
    return "";
  }

  return manejador;
};

export default CambiarFormatoFechaConHoraHelper;
